// extracted by mini-css-extract-plugin
module.exports = {"contenedorTexto":"InformacionGeneral__contenedorTexto__1P5aA","symbolOverviewWidget":"InformacionGeneral__symbolOverviewWidget__1j-p9"};